import { render, staticRenderFns } from "./AdmLinkGroup.vue?vue&type=template&id=f7f23c96&scoped=true&"
import script from "./AdmLinkGroup.vue?vue&type=script&lang=js&"
export * from "./AdmLinkGroup.vue?vue&type=script&lang=js&"
import style0 from "./AdmLinkGroup.vue?vue&type=style&index=0&id=f7f23c96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7f23c96",
  null
  
)

export default component.exports